import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Material" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {modalConfig} from './config/modal.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {usePageModal} from '@/hooks/usePageModal'
import {ref} from 'vue'
import {getGeneratUrl} from '@/service/main/promotion/generate'
import useClipboard from 'vue-clipboard3'
import {ElNotification} from 'element-plus'
import {initEmptyParam} from '@/hooks/useInitParam'
import {useRouter} from "vue-router";
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'Material',
  setup(__props) {

initEmptyParam()

const otherInfo = ref({})

const modalTitle = ref('新增')

const newCb = () => {
  modalTitle.value = '新增素材'
}

const editCb = () => {
  modalTitle.value = '编辑素材'
}

const router = useRouter()
const handleEditRtContent = (item: any) => {
  router.push({
    path: '/main/components/wangEditor',
    query: {
      materialId: item.id,
      materialUrl: item.url
    }
  })
}

const {toClipboard} = useClipboard()

const generate = async (id: string) => {
  const url = await getGeneratUrl(id)
  try {
    await toClipboard(url)
    ElNotification({
      title: '复制成功',
      message: '快去黏贴给客户吧',
      type: 'success'
    })
  } catch (e) {
    ElNotification({
      title: '复制失败',
      message: '请等一会，复制',
      type: 'error'
    })
  }
}

const store = useStore()
const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "promotionMaterial",
      deleteTip: "确认删除此素材吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData),
      onRtContentClick: handleEditRtContent,
      onSortChange: handleSortChange
    }, {
      url: _withCtx((scope) => [
        _createVNode(_component_el_link, {
          href: scope.row.url,
          type: "primary",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode("查看链接 ")
          ]),
          _: 2
        }, 1032, ["href"])
      ]),
      generate: _withCtx((scope) => [
        _createVNode(_component_el_button, {
          size: "mini",
          type: "primary",
          onClick: ($event: any) => (generate(scope.row.id))
        }, {
          default: _withCtx(() => [
            _createTextVNode("点击复制 ")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "promotionMaterial",
      otherInfo: otherInfo.value,
      validOtherInfo: () => true
    }, null, 8, ["defaultInfo", "modalConfig", "title", "otherInfo"])
  ]))
}
}

})